export const DEFAULT_SHAPE_MASK_SHORT_SIDE_RATIO = 0.6;
export const MIN_MASK_DIMENSION = 0.01;
